import { render } from "./humKxjMode.vue?vue&type=template&id=75c4a6ec&scoped=true"
import script from "./humKxjMode.vue?vue&type=script&lang=js"
export * from "./humKxjMode.vue?vue&type=script&lang=js"

import "./humKxjMode.vue?vue&type=style&index=0&id=75c4a6ec&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75c4a6ec"]])

export default __exports__